/**
 * Ticket SK15: Die Zwischenseite beim Kauf entfällt. Der Kaufknopf steht jetzt
 * unmittelbar auf der Angebotsseite (Baustein `PurchaseBox`).
 *
 * Die alte Adresse bleibt bestehen, weil sie in Anzeigen, Lesezeichen und Mails
 * stehen kann: Sie leitet dauerhaft (301) auf die zugehörige öffentliche
 * Angebotsseite um. Ist die Kennung unbekannt oder das Angebot ohne öffentliche
 * Seite, geht es auf die Kursübersicht.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";
import { getOfferPublicPath } from "@/lib/purchases.functions";

export const Route = createFileRoute("/kaufen/$slug/")({
  beforeLoad: async ({ params }) => {
    let target = "/wissen/kurse";
    try {
      const result = await getOfferPublicPath({ data: { serviceKey: params.slug } });
      target = result.path;
    } catch {
      // Nicht auflösbar: die Übersicht ist das verlässliche Ziel.
    }
    throw redirect({ href: target, statusCode: 301 });
  },
  component: () => null,
});
